var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2-Dashboard_Design-Final-Copy-2",
    "data-name": "2-Dashboard_Design-Final-Copy-2",
    transform: "translate(-32 -225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar",
    transform: "translate(32 225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.807,13.534l-2.873-.718-.245-.978a5.171,5.171,0,0,0,1.451-2.879,1.127,1.127,0,0,0,.813-.943l.187-1.5a1.123,1.123,0,0,0-.718-1.19l.069-1.412.281-.281a1.73,1.73,0,0,0,.04-2.337A3.151,3.151,0,0,0,10.972,0,4.943,4.943,0,0,0,8.13.752C4.935.818,4.5,2.3,4.5,3.75c0,.337.082,1.1.136,1.553a1.126,1.126,0,0,0-.777,1.213l.187,1.5a1.129,1.129,0,0,0,.9.965,5.2,5.2,0,0,0,1.379,2.792l-.261,1.045-2.873.718A4.206,4.206,0,0,0,0,17.625.375.375,0,0,0,.375,18h17.25A.376.376,0,0,0,18,17.624,4.209,4.209,0,0,0,14.807,13.534Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8a7f3184e0b9d5951c8c45a667d16585.svg";
export { ForwardRef as ReactComponent };